import React from "react";
import { CircularProgress, Typography } from "@material-ui/core";

interface IProps {
  message?: string
}
const GlobalLoader: React.FC<IProps> = ({message}) => {
  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: "rgba(255, 255, 255, 0.85)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 3000,
      }}
    >
      <CircularProgress size={48} />
      <Typography variant="h6" style={{ marginTop: 16 }}>
        {message || ""}
      </Typography>
    </div>
  );
};

export default GlobalLoader;
